import { EdgeLoadUserProfileRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadUserProfile } from '@/modules/auth/use-cases'

export function makeLoadUserProfile(): LoadUserProfile {
  return new EdgeLoadUserProfileRepository(makeSupabaseEdgeHttpClient()).execute
}
